import type { ReactNode } from "react";

interface UserLayoutProps {
  children: ReactNode;
  maxWidth?: string;
  presentation?: "refined";
}

export function UserLayout({ children, maxWidth = "max-w-[1080px]", presentation }: UserLayoutProps) {
  const content = (
    <div className={`mx-auto ${maxWidth} px-4 sm:px-6 lg:px-8 py-8 sm:py-12 pb-safe`}>
      {children}
    </div>
  );
  return presentation === "refined" ? <div className="journey-page">{content}</div> : content;
}
